import { z } from "zod";
import { IdSchema, IsoDateSchema } from "./common.js";

/**
 * 진실의 원천: harness/API-SPEC.md §11, docs/01_아키텍처와_데이터모델.md §7 (엑셀 이관)
 * 클라이언트(브라우저)가 방화벽.xlsx 를 파싱해 정규화까지 마친 JSON 행만 서버로 보낸다
 * (Workers CPU 10ms 보호 — harness/UI-SPEC.md §6).
 */

export const ExcelImportRowSchema = z.object({
  received_at: IsoDateSchema.nullable(), // 파싱 실패 시 null — 추정 금지(SOUL S2)
  company_raw: z.string(),
  serial_raw: z.string(),
  sender_name: z.string().nullable(),
  sender_contact: z.string().nullable(),
  memo: z.string().nullable(),
  shipped_at: IsoDateSchema.nullable(),
  // 출고일자 칸의 원문. "출고안함"·"-" 처럼 날짜가 아닌 값이 적혀 있으면
  // shipped_at 은 null 이 되는데, 원문이 없으면 서버가 그것을 조용히 버린다(SOUL S1)
  shipped_at_raw: z.string().nullable(),
  destination_raw: z.string().nullable(),
  tracking_raw: z.string().nullable(),
  memo2: z.string().nullable(),
  source_row_no: z.number().int().positive(), // 원본 엑셀 행 번호 — 대조 리포트용
});
export type ExcelImportRow = z.infer<typeof ExcelImportRowSchema>;

export const ExcelImportRequestSchema = z.object({
  source_filename: z.string(),
  rows: z.array(ExcelImportRowSchema).min(1),
});
export type ExcelImportRequest = z.infer<typeof ExcelImportRequestSchema>;

// 이관 직후 전수 대조 리포트 (docs/01 §7 4~5) — 불일치 0 이 될 때까지 완료로 보지 않는다
export const ExcelImportResponseSchema = z.object({
  legacy_evidence_id: IdSchema, // evidence.kind='legacy_excel' 로 R2 에 원본 보관
  created_case_ids: z.array(IdSchema),
  reconciliation: z.object({
    source_rows: z.number().int().nonnegative(),
    imported_rows: z.number().int().nonnegative(),
    mismatches: z.array(
      z.object({ source_row_no: z.number().int(), field: z.string(), reason: z.string() }),
    ),
  }),
});
export type ExcelImportResponse = z.infer<typeof ExcelImportResponseSchema>;
